export default {
      id: "ar_ville_recrute-usage",
      viewBox: "0 0 60 60",
      url: "../dist/images/" + "sprite.svg#ar_ville_recrute-usage",
      toString: function () {
        return this.url;
      }
    }